import {AfterContentInit, Component, EventEmitter, OnDestroy, ViewChild} from '@angular/core';
import {Observable, Subscription}                                        from 'rxjs';
import {IApPermissionData, IGridData}                                    from '../../../ap-interface';
import {ApPermissions}                                                   from 'invoker-transport';
import {
  ApTranslationsEditComponent
}                                                                        from '../../../entry-components/ap-administration-entry-components/ap-translations-edit.component';
import {
  ApDynComponentComponent
}                                                                        from '../../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridColumnConfigBase
}                                                                        from '../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                                        from '../../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  ApDynGridPropertyColumnConfig
}                                                                        from '../../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridPagerWizardConfig,
  ApDynGridPagerWizardSection
}                                                                        from '../../../ap-dyngrids/config/ap-dyn-grid-pager-wizard-config';
import {FormStore}                                                       from '../../../stores/layout/form.store';
import {MapViewStore}                                                    from '../../../stores/layout/mapview.store';
import {
  TranslationStore
}                                                                        from '../../../stores/translation/translation.store';
import {LoginStore}                                                      from '../../../stores/login/login.store';
import {
  UserSettingsStore
}                                                                        from '../../../stores/settings/usersettings.store';
import {
  ApDynGridButtonColumnConfig
}                                                                        from '../../../ap-dyngrids/config/ap-dyn-grid-button-column-config';
import {
  GetPermissionPipe
}                                                                        from '../../../ap-permission/pipes/get-permission.pipe';
import ITranslation = Data.Language.ITranslation;
import {
  ApRoleTypeService
}                                                                        from '../../../services/common/ap-role-type.service';

interface ITranslationGridData extends IGridData<ITranslation> {
  Id: any;
  StandardIcon: string;
}

@Component({
  selector: 'ap-translations',
  template: `
    <ap-dyncomponent [caption]="'Global_Translation'"
                     [canSearch]="true"
                     [headerIcon]="'ap-icon-administration'"
                     [filterTooltip]="'filterTooltip'"
                     [columns]="columns"
                     [items]="items$ | async"
                     [loading$]="translationsLoading$"
                     [pager]="pager"
                     [groupable]="true"
                     (create)="onCreate()"
                     [canCreate]="canCreate"
                     [selectable]="{checkboxOnly: false, mode: 'multiple'}"
    ></ap-dyncomponent>`
})
export class ApTranslationsComponent implements AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  columns: ApDynGridColumnConfigBase[] = [];
  items$: Observable<any>;
  pager: ApDynGridPagerConfigBase;
  translationsLoading$: Observable<boolean>;
  canCreate = ApRoleTypeService.hasAgriconRole(this.loginStore.User);
  public ApPermissions = ApPermissions;
  public apPermissionData: IApPermissionData;
  private _onEdit = new EventEmitter<any>();
  private _subscriptions: Array<Subscription> = [];
  private _canTranslateCountryCodes: Array<string> = [];

  constructor(private translationStore: TranslationStore,
              private mapViewStore: MapViewStore,
              private formStore: FormStore,
              private loginStore: LoginStore,
              private userSettingsStore: UserSettingsStore,
              private permissionPipe: GetPermissionPipe) {
    this.mapViewStore.hideMapView();
    this._subscriptions.Add(this._onEdit.subscribe(event => {
      this.formStore.openForm({component: ApTranslationsEditComponent, data: event.SourceItem});
    }));
    this._subscriptions.Add(this.userSettingsStore.Listen(s => s.data).subscribe(settings => {
      if (!settings) {
        return;
      }
      this._canTranslateCountryCodes = settings.CountryCodes;
    }));
    this.translationsLoading$ = this.translationStore.Listen(s => s.loading);
    /*this.items$ = this.translationStore.Listen(s => s.data).pipe(
      filter(d => !!d),
      map(d => Object.values(d).Convert<ITranslationGridData>(translation => {
        return {
          Id: translation.Id,
          SourceItem: translation,
          StandardIcon: 'edit'
        };
      })));*/
  }

  ngAfterContentInit(): void {
    this.gridBuilder();
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(d => {
      d.unsubscribe();
    });
  }

  onCreate(): void {
    this.formStore.openForm({component: ApTranslationsEditComponent, data: null});
  }

  private gridBuilder(): void {
    this.permissionPipe.transform(ApPermissions.EDIT_TRANSLATIONS).subscribe(() => {
      this.columns = [
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.Modul',
          title: 'Global__Module',
          headerFilterable: true,
          filterable: true,
          width: 50
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.CountryCode',
          title: 'Admin_Pages_Popups__Language',
          filterable: true,
          width: 50,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.TranslationKey',
          title: 'Admin_Pages__Keys',
          filterable: true,
          width: 50,
          headerFilterable: true,
          sortIndex: 0,
          sortDesc: true,
          groupIndex: 0,
          groupDesc: false
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.translation',
          title: 'Global_Translation',
          filterable: true,
          width: 50,
          headerFilterable: true,
        }),
        new ApDynGridButtonColumnConfig(
          {
            disabled: (t) => !this._canTranslateCountryCodes.Contains(t.SourceItem.CountryCode),
            tooltip: 'Global__Edit',
            callback: this._onEdit,
            isStandardIcon: true,
            standardIcon: 'StandardIcon'
          }
        )
      ];
    });
    this.pager = new ApDynGridPagerWizardConfig(
      new ApDynGridPagerWizardSection(),
      new ApDynGridPagerWizardSection(),
      new ApDynGridPagerWizardSection()
    );
  }
}
